export default __webpack_public_path__ + "static/media/github.d9d80171.svg";